import Reveal from '@/components/common/Reveal';
import { projects } from '@/data/projects';

const rows = projects.map(p => p.name);

export const LogoMarquee = () => (
  <section className="border-y border-border bg-secondary/40 overflow-hidden">
    <div className="mx-auto container-editorial py-6 flex items-center gap-10">
      <Reveal className="shrink-0 hidden md:block">
        <span className="label-eyebrow whitespace-nowrap">Trusted by clinics &amp; studios</span>
      </Reveal>
      <div className="relative flex-1 overflow-hidden">
        <div className="marquee-track flex gap-12 whitespace-nowrap">
          {[...rows, ...rows].map((r, i) => (
            <span key={i} className="font-serif text-2xl md:text-3xl text-muted-foreground/70">
              {r} <span className="text-sienna/70">·</span>
            </span>
          ))}
        </div>
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-secondary/40 to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-secondary/40 to-transparent pointer-events-none" />
      </div>
    </div>
  </section>
);

export default LogoMarquee;
